import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String };

  copy() {
    const url = this.urlValue;
    navigator.clipboard.writeText(url);
    this.element.textContent = "Copied!";
    setTimeout(() => (this.element.textContent = "Copy Link"), 1500);
  }
}
